import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { canActivateWorkspace } from '../../core/guards/auth.guard';
import { HomeComponent } from '../../components/home/home.component';
import { ErrorPageComponent } from 'src/app/components/error-page/error-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
    canActivate: [canActivateWorkspace],
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home',
    },
    canActivate: [canActivateWorkspace],
  },
  {
    path: 'error-page',
    component: ErrorPageComponent,
    data: {
      title: 'Error page',
    },
    canActivate: [canActivateWorkspace],
  },
  {
    path: 'auth',
    loadChildren: () => import('../authorized/auth.module').then(m => m.DpAuthModule),
    data: {
      title: 'auth',
    },
  },
  {
    path: 'workspace',
    loadChildren: () => import('../master/master.module').then(m => m.MasterModule),
    data: {
      title: 'workspace',
    },
    canActivate: [canActivateWorkspace]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}